import { useEffect, useMemo } from "react";
import { io } from "socket.io-client";
import { SITE_URL, SOCKET_PATH } from "common/api";

export const useSocket = () => {
	const socket = useMemo(() => io(SITE_URL, { path: SOCKET_PATH }), []);

	return {
		socket,
	};
};

/**
 * Custom hook to listen to multiple socket events.
 *
 * @param {Array.<[string, function(...unknown[]): void]>} args - An array of event-listener pairs.
 * @param {string} args[].event - The name of the event to listen for.
 * @param {function(...unknown[]): void} args[].listener - The function to call when the event is triggered.
 *
 * @example
 * useSocketListens([
 *   ['message', (data) => console.log(data)],
 * ]);
 */
export const useSocketListens = (args) => {
	useEffect(() => {
		const socket = io(SITE_URL, { path: SOCKET_PATH });

		args.forEach(([event, listener]) => {
			socket.on(event, listener);
		});

		return () => {
			args.forEach(([event, listener]) => {
				socket.off(event, listener);
			});

			socket.disconnect();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
